export const ErrorBoundary = () => {
  return (
    <div className="flex flex-grow items-center justify-center bg-red-100 p-4 text-red-400 font-semibold mt-4">
      There was an error in this section!!
    </div>
  );
};
